import { ReactNode } from "react";

import { STATUS_TONE_CLASS, StatusTone } from "./status-badge";
import { cn } from "./cn";

// 상태 다섯 톤에 조용한 회색·강조·위험·테두리만 더한다 — 테두리는 안쪽 ring 이라 크기가 톤마다 같다.
export type PillTone = StatusTone | "neutral" | "primary" | "danger" | "outline";

// 클래스는 문자열 그대로 적는다 — 조립하면 Tailwind 가 스캔하지 못한다.
const TONE_CLASS: Record<PillTone, string> = {
  ...STATUS_TONE_CLASS,
  neutral: "bg-muted text-muted-foreground",
  primary: "bg-primary/10 text-primary",
  danger: "bg-destructive/10 text-destructive",
  outline: "text-foreground ring-1 ring-inset ring-foreground",
};

interface Props {
  children: ReactNode;
  tone?: PillTone;
  className?: string;
}

// 알약 모양 글자 라벨(태그·종류·기본 표시) — 상태값이면 점이 붙는 StatusBadge 를 쓴다.
const Pill = ({ children, tone = "neutral", className }: Props) => (
  <span
    className={cn(
      "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold",
      TONE_CLASS[tone],
      className
    )}>
    {children}
  </span>
);

export default Pill;
